module.exports = __webpack_public_path__ + "img/select.5e1523ac.png";